<i18n src="@/locales/models/package_group_planning.yml" lang="yaml"></i18n>
<template>
  <div v-if="render">
    <div
      v-for="(package_group_planning, index) in package_plannings"
      :key="index"
    >
      <div
        class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12"
        v-show="!package_group_planning._destroy"
      >
        <div class="sm:col-span-3">
          <label :class="['label-form', isInvalidLabel('num_package_groups')]">
            {{ $t("model.package_group_planning.num_package_groups") }}
          </label>
          <div class="mt-1">
            <input
              type="text"
              v-model.number="package_group_planning.num_package_groups"
              :class="['input-text', isInvalid('num_package_groups')]"
            />
          </div>
        </div>
        <div class="sm:col-span-4">
          <label class="label-form">
            {{ $t("model.package_group_planning.agro_exporter_brand_id") }}
          </label>
          <div class="mt-1">
            <select-form
              v-if="brands.length > 0"
              :options="brands"
              :clearable="false"
              v-model="package_group_planning.agro_exporter_brand_id"
            />
          </div>
        </div>
        <div class="sm:col-span-4">
          <label class="label-form">
            {{ $t("model.package_group_planning.size_pg_plannings") }}
          </label>
          <div class="mt-1">
            <select-form
              v-if="sizes.length > 0"
              :options="sizes"
              :multiple="true"
              v-model="package_group_planning.crop_size_ids"
            />
          </div>
        </div>
        <div class="sm:col-span-1">
          <label class="label-form"></label>
          <div class="mt-8">
            <button
              class="p-2 flex items-start md:items-center mt-4 md:mt-1"
              v-if="!only_package_plannings"
              @click.prevent="removePackagePlanning(index)"
            >
              <i :class="['fa-solid fa-lg pl-1 text-blue-700', 'fa-minus']"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
      <div class="sm:col-span-3"></div>
      <div class="sm:col-span-4"></div>
      <div class="sm:col-span-4"></div>
      <div class="sm:col-span-1">
        <button
          class="p-2 flex items-start md:items-center mt-4 md:mt-1 text-right"
          @click.prevent="newPackagePlanning"
        >
          <i :class="['fa-solid fa-lg pl-1 text-blue-700', 'fa-plus']"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      package_plannings: this.modelValue,
      render: false,
    };
  },
  props: {
    modelValue: {
      type: Array,
      default: () => {
        [];
      },
    },
    brands: { type: Array },
    sizes: { type: Array },
    default_agro_exporter_brand_id: { defualt: null }
  },
  computed: {
    not_destroyed_package_plannings: function () {
      return this.package_plannings.filter(
        (package_group_planning) => !package_group_planning._destroy
      );
    },
    only_package_plannings: function () {
      return this.not_destroyed_package_plannings.length == 1;
    },
  },
  watch: {
    package_plannings: function (newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
  methods: {
    newPackagePlanning: function () {
      const empty_planning = {
        num_package_groups: null,
        agro_exporter_brand_id: this.default_agro_exporter_brand_id, // agrega por defecto el primer brand, para asegurar la validación del FK
        crop_size_ids: [],
      };
      this.package_plannings.push(empty_planning);
    },
    removePackagePlanning: function (index) {
      const package_group_planning = this.package_plannings[index];
      if (!package_group_planning) return;
      if (package_group_planning.id) {
        package_group_planning._destroy = true;
      } else {
        this.package_plannings.splice(index, 1);
      }
      if (this.package_plannings.length == 0) this.newPackagePlanning();
    },
  },
  created() {
    if (this.package_plannings.length == 0) this.newPackagePlanning();
    this.render = true;
  },
};
</script>